import { configureStore } from '@reduxjs/toolkit'
import loanReducer from './slices/loans';

const reducer = {
  loans: loanReducer
}

const store = configureStore({
  reducer: reducer,
  devTools: true,
})

export default store;